// Registry: enemy kind -> family art (ENEMY-REFORGE). Bosses are keyed by their canonical encounter name.
import type { EnemyKind } from '../../core/content';
import type { EnemyArt } from './kit';
import { ART as footman } from './footman';
import { ART as scrabbler } from './scrabbler';
import { ART as mauler } from './mauler';
import { ART as cantor } from './cantor';
import { ART as lancer } from './lancer';
import { ART as stomper } from './stomper';
import { ART as husk } from './husk';
import { ART as brood } from './brood';
import { ART as moth } from './moth';
import { ART as bulwark } from './bulwark';
import { BOSS_ART } from './bosses';
import { MAP_FOE_ART } from './mapFoes'; // MAP FOES (owner 2026-11-02)

export const FAMILY_ART: Record<Exclude<EnemyKind, 'boss'>, EnemyArt> = {
  // THE NULL HERALD: PLACEHOLDER look (the Foundry Stomper build, drawn black with a white-hot core); concept + model owed to P1
  herald: { ...stomper, name: 'Null Herald' },
  drone: footman, skitter: scrabbler, brute: mauler, caster: cantor, lancer, stomper, bomber: husk, splitter: brood, wisp: moth, warden: bulwark,
  ...MAP_FOE_ART, // MAP FOES: the renderer builds only the current map's (renderer.ts)
};
export { BOSS_ART };
export type BossName = 'IRONHIDE COLOSSUS' | 'PRISM SOVEREIGN' | 'TYRANT GUARDIAN' | 'HOLLOW TYRANT';
